/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { ContentModuleModal, TextField, CheckboxField, BlogDaySelector } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import api from '@api';

import { FORM_FIELD } from '../constants';
import Form from '../../Form';

import Item from './Item';

const EventLiveBlog = ({ visible, onSubmit, hide, previewImg, onDelete, initialValues, errors, eventBlogsList }) => {
  const [form] = Form.useForm();
  const [liveBlogId, setLiveBlogId] = React.useState(initialValues?.id || '');

  React.useEffect(() => {
    if (visible && !initialValues?.id) {
      api.liveBlogs
        .getBlogId()
        .then((res) => res)
        .then((data) => setLiveBlogId(data));
    }
  }, [initialValues, visible]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit({ id: liveBlogId, ...values });
    handleClose();
  };

  return (
    <ContentModuleModal
      visible={visible}
      title="Event Live blog"
      subtitle="Set up a live blog to include on this page"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD EVENT LIVE BLOG'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form form={form} layout="vertical" initialValues={initialValues} onFinish={handleSubmit}>
        <BlogDaySelector {...FORM_FIELD.DAY} {...{ eventBlogsList }} />
        <TextField {...FORM_FIELD.TITLE} />
        <CheckboxField {...FORM_FIELD.SHOW_TIME_STAMP} style={NO_MARGIN_BOTTOM} />
      </Form>
    </ContentModuleModal>
  );
};

EventLiveBlog.Item = Item;

export default EventLiveBlog;
